import React, { useEffect, useState } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import "./UserBids.css";
import AdminLeaderboard from "../Leaderboard/LeaderBoard";

const UserBids = () => {
  const [allBidsData, setAllBidsData] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("Bullish");
  const [showFilters, setShowFilters] = useState(false);
  const [filterSpecial, setFilterSpecial] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [sortUsers, setSortUsers] = useState(false);
  const [todaysBids, setTodaysBids] = useState([]);
  const [sortByPoints, setSortByPoints] = useState(true);
  const [filterBidAmount, setFilterBidAmount] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [showFreeBids, setShowFreeBids] = useState(true); // default is false
const [bankNiftyDay, setBankNiftyDay] = useState("All Week");


  const fetchUsers = async () => {
    try {
      const response = await fetch("https://prod-erp.nifty10.in/users/list");
      const data = await response.json();
      return data.content || [];
    } catch (error) {
      console.error("Failed to fetch users:", error);
      return [];
    }
  };

  const fetchUserBids = async (userId) => {
    try {
      const url = new URL("https://prod-erp.nifty10.in/user/bids");
      url.searchParams.append("userId", userId); // Add userId as query param

      const response = await fetch(url, {
        method: "GET",
      });

      const result = await response.json();


      return {
        userId,
        bids: Array.isArray(result?.bids) ? result.bids : [],
      };
    } catch (error) {
      console.error(`Error fetching bids for user ${userId}:`, error);
      return { userId, bids: [] };
    }
  };


  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);

      const userList = await fetchUsers();
      setUsers(userList);

      const bidsPromises = userList.map((user) => fetchUserBids(user.userId));
      const allBids = await Promise.all(bidsPromises);

      // Set time boundaries (local time converted to UTC)
      const now = new Date();

      // Set today at 9 AM (local time)
      const todayAt9am = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 0, 0, 0);
      // Convert local todayAt9am to UTC
      const todayAt9amUTC = new Date(Date.UTC(
        todayAt9am.getUTCFullYear(),
        todayAt9am.getUTCMonth(),
        todayAt9am.getUTCDate(),
        todayAt9am.getUTCHours() + 5,
        todayAt9am.getUTCMinutes() + 30,
        todayAt9am.getUTCSeconds()
      ));

      // Set yesterday at 4 PM (local time)
      const yesterdayAt4pm = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 16, 0, 0, 0);
      // Convert local yesterdayAt4pm to UTC
      const yesterdayAt4pmUTC = new Date(Date.UTC(
        yesterdayAt4pm.getUTCFullYear(),
        yesterdayAt4pm.getUTCMonth(),
        yesterdayAt4pm.getUTCDate(),
        yesterdayAt4pm.getUTCHours() + 5,
        yesterdayAt4pm.getUTCMinutes() + 30,
        yesterdayAt4pm.getUTCSeconds()
      ));


      // Filter only bids in the correct time range (between yesterday 4 PM and today 9 AM UTC)
      const filteredData = allBids
        .map(({ userId, bids }) => {
          const validBids = bids.filter((bid) => {
            const bidDate = new Date(bid.createdDate); // This is in UTC
            return bidDate >= yesterdayAt4pmUTC && bidDate <= todayAt9amUTC;
          });

          return validBids.length > 0 ? { userId, bids: validBids } : null;
        })
        .filter(Boolean); // remove nulls

      if (filteredData.length === 0) {
        console.log("No bids placed between yesterday 4 PM and today 9 AM.");
        setTodaysBids([]); // or show a message
      } else {
        setAllBidsData(filteredData);
        setTodaysBids(filteredData);
      }

      setLoading(false);
    };

    loadAllData();
  }, []);
  const handleClearFilters = () => {
    setFilterSpecial("");     // reset BigBull/BigBear filter
    setSortUsers("");      // reset user sorting
    setSelectedCompany("");
    setFilterBidAmount(""); // reset bid amount filter
    // reset selected company
    setSortByPoints(true);
    setShowFreeBids(true);

    // reset points sorting
  };


  let filteredData = [...todaysBids];

  // 1. Filter and sort individual bids for each user
  filteredData = filteredData
    .map(({ userId, bids }) => {
      // Apply bid-level filters
      let filteredBids = bids.filter((bid) => {
        const matchType = bid.dailyBid?.marketName === filterType;

        const matchSpecial =
          !filterSpecial ||
          (filterSpecial === "BigBull" && bid.listBidCompany?.some((c) => c.specialCompany && c.companyName === selectedCompany)) ||
          (filterSpecial === "BigBear" && bid.listBidCompany?.some((c) => c.specialCompany && c.companyName === selectedCompany));

        const matchBidAmount = !filterBidAmount || Number(bid.paidPoint) === Number(filterBidAmount);

        const matchFreeBid = showFreeBids ? bid.freeBid === true : bid.freeBid !== true;

        return matchType && matchSpecial && matchBidAmount && matchFreeBid;
      });


      // Sort bids by points if needed
      if (sortByPoints) {
        filteredBids.sort((a, b) => (b.totalPointCount || 0) - (a.totalPointCount || 0));
      }

      return {
        userId,
        bids: filteredBids,
      };
    })
    .filter((user) => user.bids.length > 0); // Only users with valid bids
  // 🔍 Filter users by search name
  if (searchUser.trim()) {
    const search = searchUser.toLowerCase();
    filteredData = filteredData.filter(({ userId, bids }) => {
      const user = users.find((u) => u.userId === userId);
      const matchName = user?.name?.toLowerCase().includes(search);
      const matchMobile = String(user?.mobileNo || "").toLowerCase().includes(search);
      const matchUserBidCode = bids?.some((bid) =>
        bid.userBidCode?.toLowerCase().includes(search)
      );

      return matchName || matchMobile || matchUserBidCode;
    });
  }




  // 2. Sort users by highest total points in their bids
  if (sortByPoints) {
    filteredData.sort((a, b) => {
      const maxPointsA = Math.max(...a.bids.map(bid => bid.totalPointCount || 0));
      const maxPointsB = Math.max(...b.bids.map(bid => bid.totalPointCount || 0));
      return maxPointsB - maxPointsA;
    });
  } else if (sortUsers) {
    filteredData.sort((a, b) => {
      const userA = users.find((u) => u.userId === a.userId)?.name || "";
      const userB = users.find((u) => u.userId === b.userId)?.name || "";
      return userA.localeCompare(userB);
    });
  }

  if (sortUsers) {
    filteredData.sort((a, b) => {
      const userA = users.find((u) => u.userId === a.userId)?.name || "";
      const userB = users.find((u) => u.userId === b.userId)?.name || "";
      return userA.localeCompare(userB);
    });
  }

  const allCompanies = Array.from(
    new Set(
      allBidsData.flatMap((d) =>
        d.bids.flatMap((b) => b.listBidCompany?.map((c) => c.companyName))
      )
    )
  )
    .filter(Boolean)
    .slice(0, 50)
    .sort();

  if (loading) {
    return (
      <div className="loading-container">
        <p className="loading-user-data">Loading user data</p>
      </div>
    );
  }
  const handleBackdropClick = () => {
    setShowFilters(false);
  };


  return (
    <div className="user-bids-wrapper">
      <h2 className="user-bids-title">All Users' {filterType} Bids</h2>

      <div className="user-bids-tabs">
  <button
    className={`user-bids-tab ${filterType === "Bullish" ? "active bullish-active" : ""}`}
    onClick={() => setFilterType("Bullish")}
  >
    Bullish
  </button>
  <button
    className={`user-bids-tab ${filterType === "Bearish" ? "active bearish-active" : ""}`}
    onClick={() => setFilterType("Bearish")}
  >
    Bearish
  </button>
  <button
    className={`user-bids-tab ${filterType === "BankNifty" ? "active bank-nifty" : ""}`}
    onClick={() => setFilterType("BankNifty")}
  >
    Bank Nifty
  </button>
  <button className="user-bids-filter-toggle" onClick={() => setShowFilters(!showFilters)}>
    ⚙ Filters
  </button>
</div>



      {showFilters && (
        <div className="user-bids-filter-container" onClick={handleBackdropClick}>
          <div className="filter-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="filter-modal-close-popup"
              onClick={() => setShowFilters(false)}
              aria-label="Close Filters"
            >
              ×
            </button>

            <div style={{ marginTop: "2rem" }}>
              <div className="user-bids-filters-row-1">
                <div className="user-bids-filter-item">
                  <label>Filter by:</label>
                  <select value={filterSpecial} onChange={(e) => setFilterSpecial(e.target.value)}>
                    <option value="">-- None --</option>
                    <option value="BigBull">BigBull / BigBear</option>
                  </select>
                </div>

                {filterSpecial && (
                  <div className="user-bids-filter-item">
                    <label>Special Company:</label>
                    <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
                      <option value="">-- Choose Company --</option>
                      {allCompanies.map((name, idx) => (
                        <option key={idx} value={name}>{name}</option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="user-bids-filter-item">
                  <label>Filter by Bid Amount:</label>
                  <select value={filterBidAmount} onChange={(e) => setFilterBidAmount(e.target.value)}>
                    <option value="">-- All --</option>
                    {[10, 19, 20, 29, 39, 49].map(val => (
                      <option key={val} value={val}>{val}</option>
                    ))}
                  </select>
                </div>

                {/* ✅ Moved to Row 1 */}
                <div className="user-bids-filter-item">
                  <label>Search User:</label>
                  <input
                    type="text"
                    value={searchUser}
                    placeholder="Search users"
                    onChange={(e) => setSearchUser(e.target.value)}
                  />

                </div>
              </div>
            </div>

            <div className="user-bids-filters-row-2">


              <div className="user-bids-checkbox">
                <input type="checkbox" checked={sortUsers} onChange={(e) => setSortUsers(e.target.checked)} />
                Sort Users A–Z
              </div>

              <div className="user-bids-checkbox">
                <input
                  type="checkbox"
                  checked={sortByPoints}
                  onChange={(e) => setSortByPoints(e.target.checked)}
                />
                Sort by Points (High to Low)
              </div>
              <div className="user-bids-checkbox">
                <input
                  type="checkbox"
                  checked={showFreeBids}
                  onChange={(e) => setShowFreeBids(e.target.checked)}
                />
                Show Free Bids
              </div>


              <button
                onClick={handleClearFilters}
                disabled={
                  !filterSpecial && !selectedCompany && !sortByPoints &&
                  !sortUsers && !filterBidAmount && !searchUser && !showFreeBids
                }

              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>

      )}


      {filteredData.map(({ userId, bids }) => {
        const user = users.find((u) => u.userId === userId);

        const filteredBids = bids.filter((bid) => {
          const matchType = bid.dailyBid?.marketName === filterType;

          const matchSpecial =
            !filterSpecial ||
            (filterSpecial === "BigBull" &&
              bid.listBidCompany?.some(
                (c) => c.specialCompany && c.companyName === selectedCompany
              )) ||
            (filterSpecial === "BigBear" &&
              bid.listBidCompany?.some(
                (c) => c.specialCompany && c.companyName === selectedCompany
              ));

          return matchType && matchSpecial;
        });

        if (filteredBids.length === 0) return null;

        return (
          <div key={userId} className="user-bids-user-card">
            <div className="user-bids-userinfo">
              <h3 className="user-bids-username">
                {user?.name || "Unknown User"}{" "}
                <span className="user-bids-mobile">({user?.mobileNo || "N/A"})</span>
                <span className="user-bids-bid-count">Total Bids placed: {bids.length}</span>
              </h3>

              {/* <p className="user-bids-bid-count">
                Total Bids placed: {bids.length}
              </p> */}
            </div>

            <table className="user-bids-table">
              <thead>
                <tr>
                  <th>Bid Code</th>
                  <th>Stock1</th>
                  <th>Stock2</th>
                  <th>Stock3</th>
                  <th>Stock4</th>
                  <th>Stock5</th>
                  <th>{filterType === "Bullish" ? "Big Bull" : "Big Bear"}</th>
                  <th>Points</th>  {/* 👈 Add this */}
                  <th>Amount Won</th>

                </tr>
              </thead>

              <tbody>
                {filteredBids.map((bid, index) => {
                  const companies = bid.listBidCompany || [];
                  const specialCompany = companies.find(c => c.specialCompany);

                  const isBB =
                    specialCompany?.liveBB &&
                    specialCompany?.specialCompany &&
                    specialCompany?.companyStatus?.toLowerCase() === bid.dailyBid?.marketName?.toLowerCase();

                  const specialBgColor = isBB
                    ? bid.dailyBid?.marketName?.toLowerCase() === "bullish"
                      ? "#d0f5d0"  // Green for bullish
                      : "#ffd6d6"  // Red for bearish
                    : "";         // Use empty string to clear inline style and fall back to default CSS


                  return (
                    <tr key={index}>
                      <td>{bid.userBidCode || "-"}</td>
                      {Array(5).fill(null).map((_, i) => (
                        <td key={i}>{companies[i]?.companyName || "-"}</td>
                      ))}
                      <td style={{ backgroundColor: specialBgColor || undefined }}>
                        {specialCompany?.companyName || "-"}
                      </td>


                      <td>{bid.totalPointCount?.toFixed(2) || "0.00"}</td>
                      <td>₹{bid.winningPoint?.toFixed(2) || "0.00"}</td>

                    </tr>
                  );
                })}



              </tbody>
            </table>

          </div>
        );
      })}
      {/* 📊 Separate Bank Nifty Table */}
{filterType === "BankNifty" && (
  <AdminLeaderboard />
)}

    </div>
  );
};

export default UserBids;